document.querySelectorAll( '.b-comparison' ).forEach( ( block ) => {

	const rowBlocks = Array.from( block.querySelectorAll( '.b-comparison__rows > .b-comparison-row' ) );
	if ( ! rowBlocks.length ) {

		return;

	}

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	if ( prefersReducedMotion ) {

		rowBlocks.forEach( ( rowBlock ) => rowBlock.classList.add( 'is-in-view' ) );
		return;

	}

	if ( ! ( 'IntersectionObserver' in window ) ) {

		rowBlocks.forEach( ( rowBlock ) => rowBlock.classList.add( 'is-in-view' ) );
		return;

	}

	block.classList.add( 'has-scroll-animation' );

	const observer = new IntersectionObserver(
		( entries ) => {

			entries.forEach( ( entry ) => {

				entry.target.classList.toggle( 'is-in-view', entry.isIntersecting );

			} );

		},
		{
			rootMargin: '0px 0px -12% 0px',
			threshold: 0.2,
		}
	);

	rowBlocks.forEach( ( rowBlock ) => observer.observe( rowBlock ) );

} );
